/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Center_RightInputs */



/**
* | output |
* | --- |
* | "Center Right" |
*
* @param {Input_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_center_right = /** @type {((inputs?: Input_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центристский правый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中右")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro-direita")
	return /** @type {LocalizedString} */ ("Center Right")
});